import { combineReducers } from "@reduxjs/toolkit";
import HomeReducer from './HomeReducer';
import UiReducer from './UiReducer';

const rootReducer = combineReducers({
  ui: UiReducer.reducer,
  home: HomeReducer.reducer,
});

export default rootReducer;
